import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import CONFIG from "@APP/config";
import { PAYMENT_PROVIDER } from "@APP/types";
import { MOBILE_FONT } from "@APP/styles/mobile";

/**
 * Lloyds (LBG) variant of the legal block.
 *
 * The approved designs show the LBG regulatory statement as a plain left
 * aligned paragraph, followed by the two legal links stacked underneath as
 * standalone underlined links — the base component renders them as a bulleted
 * list, which the designs do not use.
 */
// No destination is linked for LBG, so these render as labels that keep the
// design's underlined treatment without navigating anywhere.
const LEGAL_LABELS = [
  { text: "Terms and Conditions", id: "moneyhubTermsAndConditionsLink" },
  { text: "Privacy Policy", id: "moneyhubPrivacyPolicyLink" },
];

// The mobile designs run the regulatory block at the small legal size.
const MOBILE_SMALL_SX = { fontSize: `${MOBILE_FONT.small}px` };

const MoneyhubLegalInfo = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (CONFIG.PAYMENT_PROVIDER !== PAYMENT_PROVIDER.MONEYHUB) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      gap={isMobile ? "10px" : "1.5vh"}
      id={"moneyHubBox"}>
      {t("Common.MoneyhubText") ? (
        <Typography
          color="textPrimary"
          variant="body2"
          sx={isMobile ? MOBILE_SMALL_SX : undefined}
          id={"moneyHubText"}>
          {t("Common.MoneyhubText")}
        </Typography>
      ) : null}
      {LEGAL_LABELS.map(({ text, id }) => (
        <Typography
          key={id}
          component="span"
          variant="body2"
          id={id}
          color="textPrimary"
          sx={{ ...(isMobile ? MOBILE_SMALL_SX : {}), textDecoration: "underline" }}>
          {text}
        </Typography>
      ))}
    </Box>
  );
};

export default MoneyhubLegalInfo;
